import type { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import AutoSyncVisualization, {
  type Props as AutoSyncVisualizationProps,
} from 'Components/fitmentSearch/autoSyncVisualization';
import { AutoSyncVisualizationDialogName } from 'Components/names';
import { dialogOpened } from 'Core/actions/dialog';
import { usePopup } from 'Core/hooks/index';
import { useDispatch } from 'Core/store';
import { type AutoSyncPartLoader, createAutoSyncPartLoader } from 'Modules/autoSync/index';

const AutoSyncVisualizationDialog: FunctionComponent<AutoSyncVisualizationProps> = ({ template, config }) => {
  const dispatch = useDispatch();
  const [autoSyncPartNumber, setAutoSyncPartNumber] = useState<string>();
  const [partLoader, setPartLoader] = useState<AutoSyncPartLoader>();
  const { opened, close } = usePopup(AutoSyncVisualizationDialogName);

  useEffect(() => {
    window.Convermax.openAutoSyncDialog = (autoSyncId, autoSyncMpn, isTire) => {
      const autoSyncPartNumber = autoSyncId || autoSyncMpn;
      if (!autoSyncPartNumber) {
        throw new Error('autoSyncId or autoSyncMpn is required');
      }

      setAutoSyncPartNumber(autoSyncPartNumber);
      setPartLoader(createAutoSyncPartLoader(isTire, Boolean(autoSyncId)));
      dispatch(dialogOpened(AutoSyncVisualizationDialogName));
    };

    window.Convermax.openVisualizationDialog = (autoSyncMpn, isTire) => {
      window.Convermax.openAutoSyncDialog(undefined, autoSyncMpn, isTire);
    };
  }, [dispatch]);

  if (!opened) {
    return null;
  }

  const visualizationProps = {
    template,
    config: {
      height: window.innerWidth > 1024 ? 'calc(80vh - 80px)' : 'calc(100vh - 80px)',
      vehicleImageSize: 2400,
      widthAdjustment: 'scale',
      showColorPicker: true,
      vehicleAngles: [1, 32, 14], // used to add scrollabled images
      ...(config ?? {}),
    },
    autoSyncPartNumber,
    partLoader,
    extraParams: {
      close,
    },
  } satisfies AutoSyncVisualizationProps;

  return <AutoSyncVisualization {...visualizationProps} />;
};

export default AutoSyncVisualizationDialog;
